import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "Mutasi Pegawai";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const masterRegion = "Master/Region/list/";

export const List = "Kepegawaian/MutasiPegawai/List/";
export const ListDiklat = "Kepegawaian/MutasiPegawai/ListDiklat/";
export const ListDetailDiklat = "Kepegawaian/MutasiPegawai/ListDetailDiklat/";

export const ListPPI = "Kepegawaian/MutasiPegawai/ListPPI/";
export const ListUser = "Kepegawaian/MutasiPegawai/ListUser/";
export const listUserPPI = "Kepegawaian/MutasiPegawai/listUserPPI/";
export const ListDetail = "Kepegawaian/MutasiPegawai/ListDetail/";
export const ListPegawai = "Kepegawaian/MutasiPegawai/ListPegawai/";
export const ListUnitKerja = "Kepegawaian/MutasiPegawai/ListUnitKerja/";
export const ListJabatan = "Kepegawaian/MutasiPegawai/ListJabatan/";
export const Create = "Kepegawaian/MutasiPegawai/Create/";
export const Update = "Kepegawaian/MutasiPegawai/Update/";
export const CreateDetail = "Kepegawaian/MutasiPegawai/CreateDetail/";
export const Submit = "Kepegawaian/MutasiPegawai/SubmitMutasi/";

// Mutasi Baru Endpoints
export const ListMutasiBaru = "Kepegawaian/MutasiBaru/list/";
export const ListDetailMutasiBaru = "Kepegawaian/MutasiBaru/listDetail/";
export const CreateMutasiBaru = "Kepegawaian/MutasiBaru/create/";
export const CreateDetailMutasiBaru = "Kepegawaian/MutasiBaru/createDetail/";

export const DownloadTempate =
  "Kepegawaian/MutasiPegawai/downloadFamilyDocTemplate/";
export const Inactive = "Kepegawaian/MutasiPegawai/Inactive/";
export const InactiveDetail = "Kepegawaian/MutasiPegawai/inactiveDetail/";
export const Detail = "Kepegawaian/MutasiPegawai/detail/";
export const DetailMutasi = "Kepegawaian/MutasiPegawai/detailMutasi/";

export const UpdateDeparture = "Kepegawaian/MutasiPegawai/updateDeparture/";
export const UpdateArrival = "Kepegawaian/MutasiPegawai/updateArrival/";
export const UpdateReturn = "Kepegawaian/MutasiPegawai/updateReturn/";
export const ConfirmReturn = "Kepegawaian/MutasiPegawai/confirmReturn/";
export const DetailMutasiPegawai =
  "Kepegawaian/MutasiPegawai/detailMutasiPegawai/";
export const UpdateMutasiPegawai =
  "Kepegawaian/MutasiPegawai/updateMutasiPegawai/";

export const UpdateTMTStart = "Kepegawaian/MutasiPegawai/updateTMTStart/";
export const UpdateTMTEnd = "Kepegawaian/MutasiPegawai/updateTMTEnd/";
export const UploadDecree = "Kepegawaian/MutasiPegawai/uploadDecree/";
export const UpdateSuratKeputusan =
  "Kepegawaian/MutasiPegawai/UpdateSuratKeputusan/";
export const UpdateSuratKeputusanPPI =
  "Kepegawaian/MutasiPegawai/UpdateSuratKeputusanPPI/";
export const UpdateSPKeluarga = "Kepegawaian/MutasiPegawai/UpdateFamilyDoc/";
export const UpdateSpp = "Kepegawaian/MutasiPegawai/UpdateSpp/";
export const UpdateSpmj = "Kepegawaian/MutasiPegawai/UpdateSpmj/";
export const UpdateSpmt = "Kepegawaian/MutasiPegawai/UpdateSpmt/";
export const bknServiceSendJabatan =
  "Kepegawaian/IntegrasiSimpegBkn/bknServiceSendJabatanMutasi/";
export const bknServiceSendJabatanAll =
  "Kepegawaian/IntegrasiSimpegBkn/bknServiceSendJabatanMutasiAll/";

export const coupleList = "Kepegawaian/RiwayatNikah/list/";
export const childList = "Kepegawaian/Anak/list/";
export const gradeList = "Kepegawaian/MutasiPegawai/gradeList/";
export const listSKPPI = "Kepegawaian/MutasiPegawai/listSKPPI/";
export const checkPositionQuota =
  "Kepegawaian/MutasiPegawai/checkPositionQuota/";
export const cekmandatory = "Kepegawaian/MutasiPegawai/cekmandatory/";
export const fetchExport = "Kepegawaian/MutasiPegawai/export_data/";



export const LegalList = "Kepegawaian/MutasiPegawai/LegalList/";
export const StatusList = "Kepegawaian/MutasiPegawai/StatusList/";




export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
